import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/Home'
import login from '@/views/Login'
import userinfo from '@/views/Userinfo'
import costList from '@/views/CostList'
import userCenter from '@/views/UserCenter'
import historyTrainProgram from '@/views/HistoryTrainProgram'
import programDetail from '@/views/ProgramDetail'
import serverComChange from '@/views/ServerComChange'
import noticeList from '@/views/NoticeList'
import noticeDetail from '@/views/NoticeDetail'
import video from '@/views/vedioDemo'
import videoD from '@/views/videoDetail' // 视频详情
import pdfWatcher from '@/views/pdfWatcher'
import authorization from '@/views/Authorization'
import test from '@/views/Test'
import feeDetail from '@/views/FeeDetail' // 费用详情
import toPay from '@/views/ToPay' // sgaqy
import weiVideo from '@/views/WeiVideo' // 微视频
import train from '@/views/TrainList' // 培训列表
import continueEdu from '@/views/ContinueEdu' // 继续教育
import specialStudy from '@/views/SpecialStudy' // 专项学习
import safeStudy from '@/views/SafeStudy' // 安全学习and plan.id=1
import examEnter from '@/views/ExamEnter' // 考核
import classTest from '@/views/classTest' // 随堂测试
import videoLists from '@/views/VideoLists' // 课程列表
import videoGroup from '@/views/videoGroup' // 本期课程单元
import videoPlay from '@/views/VideoPlay' // 不记时视频播放
import shouc from '@/views/Shouc' // 我的收藏
import RoadTransList from '@/views/RoadTransList' // 道路运输继续教育
import runBook from '@/views/runBook'// 驾驶员操作手册
import safeLearing from '@/views/SafeLearning'// 安全学习
import twoClass from '@/views/twoClass'// 安全学习

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '',
  routes: [
    {
      path: '/vPlay',
      name: '视频播放',
      component: videoPlay
    },
    {
      path: '/vGroup',
      name: '本期课程单元',
      component: videoGroup
    },
    {
      path: '/vList',
      name: '课程列表',
      component: videoLists
    },
    {
      path: '/eEnter',
      name: '考核',
      component: examEnter
    },
    {
      path: '/cEdu',
      name: '出租车继续教育',
      component: continueEdu
    },
    {
      path: '/spStudy',
      name: '岗前培训',
      component: specialStudy
    },
    {
      path: '/sfStudy',
      name: '安全学习',
      component: safeLearing
    },
    {
      path: '/twoClass',
      name: '两类人员',
      component: twoClass
    },
    {
      path: '/train',
      name: '培训',
      component: train
    },
    {
      path: '/weiV',
      name: '微视频',
      component: weiVideo
    },
    {
      path: '/videoD',
      name: '课程详情',
      component: videoD
    },
    {
      path: '/feed',
      name: '费用详情',
      component: feeDetail
    },
    {
      path: '/pay',
      name: '确认订单',
      component: toPay
    },
    {
      path: '/test',
      name: '考试',
      component: test
    },
    {
      path: '/cTest',
      name: '随堂测试',
      component: classTest
    },
    {
      path: '/',
      name: '远程教育',
      component: home
    },
    {
      path: '/v',
      name: '视频播放',
      component: video
    },
    {
      path: '/pdf',
      name: '课件查看',
      component: pdfWatcher
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
    {
      path: '/Au',
      name: '正在授权',
      component: authorization
    },
    // 用户中心
    {
      path: '/uc',
      name: '用户中心',
      component: userCenter
    },
    // 个人信息
    {
      path: '/ui',
      name: '个人信息',
      component: userinfo
    },
    // 费用清单
    {
      path: '/cl',
      name: '订单',
      component: costList
    },
    // 费用清单
    {
      path: '/cl',
      name: '订单',
      component: costList
    },
    // 我的收藏
    {
      path: '/sc',
      name: '我的收藏',
      component: shouc
    },
    // 历史培训计划
    {
      path: '/hp',
      name: '历史培训计划',
      component: historyTrainProgram
    },
    // 计划详情
    {
      path: '/pd',
      name: '计划详情',
      component: programDetail
    },
    // 服务单位转移
    {
      path: '/sc',
      name: '服务单位转移',
      component: serverComChange
    },
    // 公告列表
    {
      path: '/nl',
      name: '消息公示栏',
      component: noticeList
    },
    // 公告详情
    {
      path: '/nd',
      name: '消息袋',
      component: noticeDetail
    },
    // 驾驶员操作手册
    {
      path: '/runB',
      name: '消息袋',
      component: runBook
    },
    {
      path: '/rt',
      name: '道路运输继续教育',
      component: RoadTransList
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js